<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">Edit Customer '{{Edit_Customer_Record.name}}'</h5>
    <form [formGroup]="EdCustomer">

      <input type="hidden" formControlName="id" />

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Customer Name (*) </label>
          <input type="text" class="form-control" disabled value="{{Edit_Customer_Record.name}}" />
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Customer Code (*) </label>
          <input type="text" class="form-control" disabled value="{{Edit_Customer_Record.code}}" />
        </div>
      </div>

      <div class="row" *ngIf="false">

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Province </label>
          <select class="custom-select" formControlName="ProvinceId" (change)="ProvinceChange()">
            <option value="0">Select</option>
            <option *ngFor="let item of DataList_Province" [value]="item.code">{{item.title}}</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">County</label>
          <select class="custom-select" formControlName="CityId">
            <option value="0">Select</option>
            <option *ngFor="let item of DataList_City" [value]="item.id">{{item.title}}</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Field of Activity</label>
          <select class="custom-select" formControlName="FeildActivity">
            <option value="0">Select</option>
            <option *ngFor="let item of DataList_FeildActivity" [value]="item.id">{{item.title}}</option>
          </select>
        </div>
      </div>


      <div class="row" style="display: none;">

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Registration Number</label>
          <input type="number" formControlName="ShomarehSabt" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_ShomarehSabt().valid && get_Form_ShomarehSabt().touched"
            class="form-text text-muted MyErrorRedColor">Enter the registration number.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Economic Code</label>
          <input type="number" formControlName="CodeEghtesadi" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_CodeEghtesadi().valid && get_Form_CodeEghtesadi().touched"
            class="form-text text-muted MyErrorRedColor">Enter the economic code.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1"> National ID (without leading zero) </label>
          <input type="number" formControlName="CodeMeli" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_CodeMeli().valid && get_Form_CodeMeli().touched"
            class="form-text text-muted MyErrorRedColor">Enter the national ID.</small>
        </div>
      </div>

      <br />
      <hr />
      <br />

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Managing Director Full Name</label>
          <input type="text" formControlName="ModirAmelName" class="form-control" placeholder="Type here...">
        </div>

      </div>
      <div class="row" style="display: none;">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Mobile Number (without leading zero) </label>
          <input type="number" formControlName="ModirAmelMobile" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_ModirAmelMobile().valid && get_Form_ModirAmelMobile().touched"
            class="form-text text-muted MyErrorRedColor">Enter the mobile number.</small>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Phone</label>
          <input type="number" formControlName="ModirAmelTel" class="form-control" placeholder="Type here...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Internal</label>
          <input type="number" formControlName="ModirAmelDakheli" class="form-control"
            placeholder="Type here...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Email</label>
          <input type="email" formControlName="ModirAmelEmail" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_ModirAmelEmail().valid && get_Form_ModirAmelEmail().touched"
            class="form-text text-muted MyErrorRedColor">Enter the email address.</small>
        </div>
      </div>
    </form>



    <br />
    <hr />
    <br />

    <h5 *ngIf="AddressForm_Edit_Id==-1"> Address </h5>
    <h5 *ngIf="AddressForm_Edit_Id>-1"> Edit Address </h5>

    <form [formGroup]="AddressCustomer" (submit)="OnSubmit_AddressForm()">

      <input type="hidden" formControlName="id">

      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">Address Title</label>
          <input type="text" formControlName="title" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_AddressCustomer_title().valid && get_Form_AddressCustomer_title().touched"
            class="form-text text-muted MyErrorRedColor">Enter the address title.</small>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">Address</label>
          <input type="text" formControlName="address" class="form-control" placeholder="Type here...">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">Certificate Address</label>
          <input type="text" formControlName="certificateAddress" class="form-control"
            placeholder="Type here...">
          <small
            *ngIf="!get_Form_AddressCustomer_certificateAddress().valid && get_Form_AddressCustomer_certificateAddress().touched"
            class="form-text text-muted MyErrorRedColor">Enter the certificate address (maximum 50 characters). </small>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Postal Code</label>
          <input type="number" formControlName="codepost" class="form-control" placeholder="Type here...">
        </div>
        <div class="form-group col-md-3" style="display: none;">
          <label for="exampleInputEmail1">P.O. Box</label>
          <input type="number" formControlName="sandoghpost" class="form-control" placeholder="Type here...">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Area Code</label>
          <input type="number" formControlName="pishShomareh" class="form-control" placeholder="Type here...">
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Phone</label>
          <input type="number" formControlName="Tel" class="form-control" placeholder="Type here...">
        </div>
        <div class="form-group col-md-3" style="display: none;">
          <label for="exampleInputEmail1">Internal</label>
          <input type="number" formControlName="Dakheli" class="form-control" placeholder="Type here...">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Fax</label>
          <input type="number" formControlName="Fax" class="form-control" placeholder="Type here...">
        </div>
      </div>


      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">Description</label>
          <input type="text" formControlName="Dsc" class="form-control" placeholder="Type here...">
        </div>
      </div>



      <button *ngIf="AddressForm_Edit_Id==-1" type="submit" [disabled]="!AddressCustomer.valid" class="btn btn-success"
        style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Address </button>
      <button *ngIf="AddressForm_Edit_Id==-1" type="reset" class="btn btn-danger" style="margin-right: 5px;"><i
          class="fa fa-times-rectangle"></i> Cancel </button>

      <button *ngIf="AddressForm_Edit_Id>-1" type="submit" [disabled]="!AddressCustomer.valid" class="btn btn-info"
        style="margin-right: 5px;"><i class="fa  fa-edit"></i> Edit Address </button>
      <button *ngIf="AddressForm_Edit_Id>-1" type="button" (click)="AddressForm_Edit_Cancel()" class="btn btn-danger"
        style="margin-right: 5px;"><i class="fa fa-times-rectangle"></i> Cancel Editing </button>

    </form>

    <br />
    <br />

    <div class="table-responsive" *ngIf="DataList_Address.length>0 && AddressForm_Edit_Id==-1">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>Address Title</th>
            <th>Address</th>
            <th>Certificate Address</th>
            <th>Postal Code</th>
            <th>Area Code</th>
            <th>Phone</th>
            <th>Fax</th>
            <th>Description</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of DataList_Address">
            <td>{{DataList_Address.indexOf(item)+1}}</td>
            <td>{{item.title}}</td>
            <td>{{item.address}}</td>
            <td>{{item.certificateAddress}}</td>
            <td>{{item.codepost}}</td>
            <td>{{item.pishShomareh}}</td>
            <td>{{item.tel}}</td>
            <td>{{item.fax}}</td>
            <td>{{item.dsc}}</td>
            <td>
              <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                <div class="btn-group" role="group">
                  <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Actions
                  </button>
                  <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                    <a style="cursor: pointer;" (click)="AddressForm_Edit(DataList_Address.indexOf(item))"
                      class="dropdown-item"><i class="fa fa-edit"></i> Edit </a>
                    <a style="cursor: pointer;" (click)="AddressForm_Delete(DataList_Address.indexOf(item))"
                      class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>
                  </div>
                </div>
              </div>
            </td>

          </tr>
        </tbody>
      </table>
    </div>

    <br />
    <hr />
    <br />

    <app-CutomerKarshnasForm
    [inner_Customer]="-1"
    (outter_KarshnasMasol)="set_KarshnasMasol($event)">
    
    </app-CutomerKarshnasForm>


    <button *ngIf="!Proccesing_OnSubmitForm" type="button" (click)="OnSubmitForm()" [disabled]="!EdCustomer.valid"
      class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-plus"></i> Confirm and Save Customer Information
    </button>
    <button *ngIf="Proccesing_OnSubmitForm" type="button" class="btn btn-info" style="margin-right: 5px;"> Please wait... <i class="fa fa-spin fa-spinner"></i> </button>

  </div>
</div>